import React, { useEffect } from 'react';

import dynamic from 'next/dynamic';

import { useFeatures } from '@atc/features';

// Utilities
import timingUtil from '@/utilities/timingUtil';

import LazyComponent from '@/components/LazyComponent';

const FooterContentInjector = dynamic(() => import('reaxl-footer/atc').then((mod) => mod.FooterContentInjector), { ssr: false });

function FooterContainer() {
    const {
        ads: [enableAds],
        thirdparty: [enableThirdParty],
        opinion_lab: [isOpinionLabEnabled],
    } = useFeatures([
        'ads',
        'thirdparty',
        'opinion_lab',
    ]);

    useEffect(() => {
        timingUtil.markUserTime('footer-rendered');
    }, []);

    if (isOpinionLabEnabled) {
        return (
            <LazyComponent>
                <FooterContentInjector renderThirdParty={enableThirdParty && enableAds} />
            </LazyComponent>
        );
    }

    return null;
}

export default React.memo(FooterContainer);
